import { useNavigate } from 'react-router-dom';
import './style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import { useMemo } from 'react';

type NotFoundDataBackPageHome = {
  kind: 'home';
};

type NotFoundDataBackPagePrevious = {
  kind: 'previous';
};

type NotFoundDataBackPageTarget = {
  kind: 'target';
  label: string;
  navigate: () => void;
};

export type NotFoundDataBackPageType =
  | NotFoundDataBackPageHome
  | NotFoundDataBackPagePrevious
  | NotFoundDataBackPageTarget;

export type NotFoundDataProps = {
  message?: string;
  backPageType: NotFoundDataBackPageType;
};

export const NotFoundData = (props: NotFoundDataProps) => {
  const navigate = useNavigate();

  const backPageProps = useMemo(() => {
    switch (props.backPageType.kind) {
      case 'home':
        return {
          label: 'HOMEに戻る',
          onClick: () => navigate(PagePath.Home),
        };
      case 'previous':
        return {
          label: '前の画面に戻る',
          onClick: () => navigate(-1),
        };
      case 'target':
        return {
          label: props.backPageType.label,
          onClick: props.backPageType.navigate,
        };
    }
  }, [props.backPageType]);

  return (
    <div className="notFoundData">
      <Description
        label={props.message || 'お探しのデータが見つかりませんでした。'}
        labelColor={labelColor.black}
        labelSize={labelSize.medium}
      />
      <Button
        label={backPageProps.label}
        buttonFill={ButtonFill.link}
        buttonSize={ButtonSize.small}
        onClick={backPageProps.onClick}
      />
    </div>
  );
};
